import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { LessonType } from '@app/store/shared/models';
import { TYPE_CHIP_CONFIGS } from '@shared/types/chip.type';

@Component({
    selector: 'app-lesson-add-modal',
    templateUrl: './add.component.html',
    styleUrls: ['./add.component.css'],
    imports: [TranslateModule],
})
export class AddComponent {
    private readonly router = inject(Router);
    private readonly route = inject(ActivatedRoute);
    private readonly translateService = inject(TranslateService);

    readonly types: { label: string; value: LessonType; icon: string }[] = [
        { value: 'video', label: this.translateService.instant('lessons.type.video'), icon: TYPE_CHIP_CONFIGS['video'].icon },
        { value: 'audio', label: this.translateService.instant('lessons.type.audio'), icon: TYPE_CHIP_CONFIGS['audio'].icon },
        { value: 'text', label: this.translateService.instant('lessons.type.text'), icon: TYPE_CHIP_CONFIGS['text'].icon },
    ];

    selectType(type: LessonType): void {
        this.router.navigate(['../', type], { relativeTo: this.route });
    }

    close(): void {
        const outlet = this.route.parent?.outlet ?? 'modal';
        this.router.navigate([{ outlets: { [outlet]: null } }]);
    }
}
